import { Component, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { InterimModel } from '../interfaces/interim.interface';

@Component({
    selector: 'pace-fi-interims-limit',
    templateUrl: './interims-limit.component.html',
    styleUrls: ['./interims-limit.component.scss'],
    standalone: false,
})
export class InterimsLimitComponent {
    @Input()
    public interims: InterimModel[];
    public constructor(public readonly modalInstance: BsModalRef) {}
}
